export const MIN_MANUAL_DURATION = 5;
export const MAX_MANUAL_DURATION = 120;
export const MANUAL_DURATION_STEP = 5;
